import * as R from 'ramda'

export default R.curry((property, object) =>
  R.ifElse(R.has(property), R.pick([property]), R.always(null))(object)
)
